<svg *ngIf="href" [attr.width]="width" [attr.height]="height" [attr.viewBox]="'0 0 ' + width + ' ' + height">
  <title *ngIf="alt">{{alt}}</title>
  <use [attr.href]="href"></use>
</svg>
